<p-dialog
  header="Nuova scheda"
  [(visible)]="visible"
  [style]="{width: '80%', height: '91%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [closable]="false"
  styleClass="p-dialog-scheda-nuova"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span class="material-icons header-icon">map</span>
      <h2 *ngIf="!isEnteEsecutore">Nuova scheda</h2>
      <h2 *ngIf="isEnteEsecutore">Proponi nuova scheda</h2>
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-danger close-button"
        (click)="hide()"
        [disabled]="submitting"
        pTooltip="Chiudi"
        tooltipPosition="left">
      </button>
    </div>
  </ng-template>

  <form [formGroup]="schedaForm" (ngSubmit)="onSubmit()">
    <!-- Wizard Steps -->
    <div style="margin-top: 1.5rem; margin-bottom: 1rem;">
      <p-steps [model]="items" [activeIndex]="currentStep" [readonly]="false" (activeIndexChange)="onStepChange($event)"></p-steps>
    </div>

    <div class="p-fluid">
      <!-- Step 1: Dati della Scheda -->
      <div *ngIf="currentStep === 0">
        <!-- Bacino, Comune e Rio/Località -->
        <div class="p-d-flex" style="display: flex; gap: 1rem; margin-bottom: 1.5rem; margin-top: 1rem;">
          <div class="field" style="flex: 0.7;">
            <label for="bacino">Bacino <span class="required-asterisk">*</span></label>
            <p-dropdown
              id="bacino"
              formControlName="bacino"
              [options]="bacini"
              optionLabel="denominazione"
              placeholder="Seleziona bacino"
              [showClear]="true"
              styleClass="w-full"
              (onChange)="onBacinoChange($event)"
              [appendTo]="'body'"
              [panelStyle]="{width: 'auto'}"
            >
            <ng-template let-bacino pTemplate="item">
              <div class="bacino-badge" style="margin: 0">
                <span class="code-value">{{ bacino.denominazione }}</span>
              </div>
            </ng-template>
          </p-dropdown>
          </div>

          <div class="field" style="flex: 1;">
            <label for="comune">Comune <span class="required-asterisk">*</span></label>
            <p-dropdown
              id="comune"
              formControlName="comune"
              [options]="comuni"
              optionLabel="denominazione"
              placeholder="Seleziona comune"
              [showClear]="true"
              styleClass="w-full"
              [appendTo]="'body'"
              [panelStyle]="{width: 'auto'}"
            >

            <ng-template let-comune pTemplate="item">
              <div class="comune-badge" style="margin: 0">
                <span class="code-value">{{ comune.denominazione }}</span>
              </div>
            </ng-template>
          </p-dropdown>
          </div>
          <div class="field" style="flex: 1;">
            <label for="rioLocalita">Rio/Località</label>
            <input pInputText id="rioLocalita" formControlName="rioLocalita" placeholder="Inserisci rio o località" />
          </div>
        </div>

       <!--  <div class="p-d-flex" style="display: flex; gap: 1rem; margin-bottom: 1.5rem;">
          <div class="field" style="flex: 1;">
            <label for="titolo">Titolo <span class="required-asterisk">*</span></label>
            <input pInputText id="titolo" formControlName="titolo" placeholder="Inserisci il titolo della scheda" class="w-full" />
          </div>

        </div> -->

        <div class="p-d-flex" style="display: flex; gap: 1rem; margin-bottom: 1.5rem;">
          <div class="field" style="flex: 0.4;">
            <label for="oggetto">Oggetto dell'intervento <span class="required-asterisk">*</span></label>
            <p-dropdown
              id="oggetto"
              formControlName="oggettoIntervento"
              [options]="oggettiIntervento"
              optionLabel="descrizione"
              placeholder="Seleziona oggetto di intervento"
              [showClear]="true"
              [appendTo]="'body'"

            >
              <ng-template pTemplate="selectedItem" let-item>
                <div class="selected-object-item">
                  <span class="object-badge"
                        [ngStyle]="{'background-color': stiliService.getColoreOggettoIntervento(item), 'color': '#000000'}">
                    {{ item.codice }}
                  </span>
                   <span style="font-size: 10px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px; display: inline-block;">{{ item.descrizione }}</span>

                </div>
              </ng-template>
              <ng-template pTemplate="item" let-item>
                <div class="dropdown-item" >
                  <span class="object-badge"
                        [ngStyle]="{'background-color': stiliService.getColoreOggettoIntervento(item), 'color': '#000000'}">
                    {{ item.codice }}
                  </span>
                  <span style="font-size: 10px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px; display: inline-block;">{{ item.descrizione }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="field" style="flex: 0.3;">
            <label for="codiceAto">Codice ATO <span class="required-asterisk">*</span></label>
            <p-dropdown
              id="codiceAto"
              formControlName="codiceAto"
              [options]="codiciAtoFiltrati"
              optionLabel="descrizione"
              placeholder="Seleziona codice ATO"
              [showClear]="true"
              [appendTo]="'body'"
            >
              <ng-template pTemplate="selectedItem" let-item>
                <div class="selected-object-item">
                  <span class="object-badge"
                        [ngStyle]="{'background-color': stiliService.getColoreCodiceAto(item.codice), 'color': '#000000'}">
                    {{ item.codice }}
                  </span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-item>
                <div class="dropdown-item" >
                  <span class="object-badge"
                        [ngStyle]="{'background-color': stiliService.getColoreCodiceAto(item.codice), 'color': '#000000'}">
                    {{ item.codice }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="field" style="flex: 0.1;">
            <label for="frequenza">Frequenza</label>
            <p-inputNumber
              id="frequenza"
              formControlName="frequenza"
              [min]="1"
              [max]="12"
              spinnerMode="horizontal"
              placeholder="1"
              styleClass="w-full"
              [style]="{'height': '50px'}"
            ></p-inputNumber>
          </div>
          <div class="field" style="flex: 0.2;">
            <label for="accessibilita">Accessibilità</label>
            <p-dropdown
              id="accessibilita"
              formControlName="accessibilita"
              [options]="accessibilita"
              optionLabel="descrizione"
              placeholder="Seleziona accessibilità"
              [showClear]="true"
              styleClass="w-full"
              [appendTo]="'body'"
              [panelStyle]="{width: 'auto'}"
            >
              <ng-template pTemplate="selectedItem" let-item>
                <div class="selected-item" *ngIf="item">
                  <span class="accessibilita-icon" [ngStyle]="stiliService.getStileAccessibilitaCompatto(item.id)">
                    <span *ngIf="item.id !== 2 && item.id !== 3" class="material-icons" [ngStyle]="stiliService.getStileIconaAccessibilita(item.id)">
                      {{ stiliService.getIconaAccessibilita(item.id) }}
                    </span>
                    <img [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" *ngIf="item.id === 2" src="assets/icons/car-suv.svg" alt="car-suv">
                    <img [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" *ngIf="item.id === 3" src="assets/icons/car-crane.svg" alt="car-crane">
                  </span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-item>
                <div class="dropdown-item">
                 <!--  <span class="accessibilita-icon" [ngStyle]="stiliService.getStileAccessibilitaCompatto(item.id)">
                    <span class="material-icons" [ngStyle]="stiliService.getStileIconaAccessibilita(item.id)">
                      {{ stiliService.getIconaAccessibilita(item.id) }}
                    </span>
                  </span> -->
                  <span class="accessibilita-icon" [ngStyle]="stiliService.getStileAccessibilitaCompatto(item.id)">
                    <span *ngIf="item.id !== 2 && item.id !== 3" class="material-icons" [ngStyle]="stiliService.getStileIconaAccessibilita(item.id)" >
                      {{ stiliService.getIconaAccessibilita(item.id) }}
                    </span>
                    <img [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" *ngIf="item.id === 2" src="assets/icons/car-suv.svg"   alt="car-suv" >
                    <img [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" *ngIf="item.id === 3" src="assets/icons/car-crane.svg" alt="car-crane" >

                  </span>

                  <span style="font-size: 10px;">{{ item.descrizione }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="form-group full-width">
          <label for="note">Note</label>
          <textarea pInputTextarea id="note" formControlName="note" rows="3" placeholder="Inserisci eventuali note" style="resize: vertical"></textarea>
        </div>
      </div>

      <!-- Step 2: Caricamento File -->
      <div *ngIf="currentStep === 1" class="step-content">
        <h4>Carica ALLEGATI</h4>
        <div style="display: flex; margin-top: 1rem; width: 100%;">
          <div class="card-pdf-upload" style="flex: 1; margin-right: 0.5rem;">
            <div *ngIf="!uploadedPdf">
              <p-fileUpload
                #fileUpload
                mode="basic"
                chooseLabel="Seleziona PDF"
                accept="application/pdf"
                [maxFileSize]="10000000"
                [auto]="false"
                [disabled]="submitting"
                [style]="{'width':'100%'}"
                styleClass="p-button-outlined p-button-primary upload-button"
                (onSelect)="onPDFSelect($event)"
                (onClear)="onPDFClear()"
              >
              </p-fileUpload>
            </div>
            <div *ngIf="uploadedPdf" class="file-info mt-3">
              <i class="pi pi-file-pdf" style="font-size: 1.5rem; color: #5351b9;"></i>
              <div class="file-details">
                <span class="file-name">{{ uploadedPdf.name }}</span>
                <span class="file-size">{{ (uploadedPdf.size / 1024 / 1024).toFixed(2) }} MB</span>
              </div>

              <button
                pButton
                type="button"
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger ml-auto"
                pTooltip="Rimuovi file">
              </button>
            </div>
          </div>

          <div class="card-pdf-upload" style="flex: 1; margin-left: 0.5rem;">
            <div *ngIf="!uploadedExcel">
              <p-fileUpload
                #fileUpload
                mode="basic"
                chooseLabel="Seleziona Excel"
                accept=".xlsx,.xls"
                [maxFileSize]="10000000"
                [auto]="false"
                [disabled]="submitting"
                [style]="{'width':'100%'}"
                styleClass="p-button-outlined p-button-primary upload-button"
                (onSelect)="onExcelSelect($event)"
                (onClear)="onExcelClear()"
              >
              </p-fileUpload>
            </div>
            <div *ngIf="uploadedExcel" class="file-info mt-3">
              <i class="pi pi-file-excel" style="font-size: 1.5rem; color: #0d7b6c;"></i>
              <div class="file-details">
                <span class="file-name">{{ uploadedExcel.name }}</span>
                <span class="file-size">{{ (uploadedExcel.size / 1024 / 1024).toFixed(2) }} MB</span>
              </div>

              <button
                pButton
                type="button"
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger ml-auto"
                pTooltip="Rimuovi file">
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 3: Mappa -->
      <div *ngIf="currentStep === 2" class="step-content">
        <h3>Carica la posizione dell'opera</h3>
        <div class="upload-container" style="margin-top: 2rem;" *ngIf="!uploadedGeoJSON">
          <div class="card-pdf-upload" style="width: 100%;">
            <p-fileUpload
              mode="basic"
              chooseLabel="Seleziona GeoJSON"
              accept=".geojson,.json"
              [maxFileSize]="10000000"
              [auto]="false"
              [disabled]="submitting"
              [style]="{'width':'100%'}"
              styleClass="p-button-outlined p-button-primary upload-button"
              (onSelect)="onGeoJSONSelect($event)"

            >
            </p-fileUpload>
          </div>
        </div>

       <!--  <div *ngIf="uploadedGeoJSON" class="file-info mt-3">
          <i class="pi pi-map" style="font-size: 1.5rem; color: #2196F3;"></i>
          <div class="file-details">
            <span class="file-name">{{ uploadedGeoJSON.name }}</span>
            <span class="file-size">{{ (uploadedGeoJSON.size / 1024 / 1024).toFixed(2) }} MB</span>
          </div>
          <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-danger ml-auto"
            (click)="onGeoJSONClear()"
            pTooltip="Rimuovi file">
          </button>
        </div> -->

        <!-- Mappa visibile quando c'è un file GeoJSON caricato -->
        <div class="mappa-container" *ngIf="uploadedGeoJSON">
          <div class="map-actions">
            <button
              pButton
              pTooltip="{{opzioniMappa.mostraComuni ? 'Nascondi confini comuni' : 'Mostra confini comuni'}}"
              tooltipPosition="bottom"
              [icon]="opzioniMappa.mostraComuni ? 'pi pi-eye-slash' : 'pi pi-eye'"
              (click)="toggleConfiniComuni()"
              class="p-button-rounded p-button-text">
            </button>
            <button
              pButton
              pTooltip="Sostituisci GeoJSON"
              tooltipPosition="bottom"
              icon="pi pi-refresh"
              (click)="onGeoJSONClear()"
              class="p-button-rounded p-button-text p-button-warning">
            </button>
          </div>
          <div #map id="map"></div>
        </div>
      </div>

      <!-- Wizard Navigation -->
      <div class="step-navigation" style="display: flex; justify-content: space-between; margin-top: 2rem;">
        <button
          pButton
          type="button"
          label="Indietro"
          class="p-button-outlined"
          [disabled]="currentStep === 0"
          (click)="previousStep()"
        ></button>

        <button
          pButton
          type="button"
          label="Avanti"
          class="p-button-primary"
          *ngIf="currentStep < 2"
          [disabled]="!isStepValid(currentStep)"
          (click)="nextStep()"
        ></button>

        <button
          pButton
          type="submit"
          label="Crea scheda"
          class="p-button-success"
          *ngIf="currentStep === 2"
          [loading]="submitting"
          [disabled]="!isFormValid() || submitting"
        ></button>
      </div>
    </div>

    <div class="form-footer" *ngIf="false">
    <!--   <div class="note-required">
        <span class="required-asterisk">*</span> Campo obbligatorio
      </div> -->
      <div class="dialog-actions">
        <button
          pButton
          type="button"
          label="Annulla"
          class="p-button-outlined p-button-secondary"
          (click)="hide()"
          [disabled]="submitting"
        ></button>
        <button
          pButton
          type="submit"
          label="Crea scheda"
          class="p-button-success"
          [loading]="submitting"
          [disabled]="schedaForm.invalid || submitting"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<!-- Modale per mostrare il codice della scheda creata -->
<p-dialog
  header="Scheda creata con successo"
  [(visible)]="showCodiceModal"
  [style]="{width: '500px'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [closable]="true"
  styleClass="codice-scheda-modal">
  <ng-template pTemplate="header">
    <div class="dialog-header-success">
      <i class="pi pi-check-circle success-icon"></i>
      <h3>Scheda creata con successo</h3>
    </div>
  </ng-template>

  <div class="codice-container">
    <p class="codice-label">Codice della scheda appena creata</p>
    <div class="codice-display">
      <code class="codice-value">{{ codiceSchedaCreata }}</code>
      <button
        pButton
        type="button"
        [icon]="codiceCopiato ? 'pi pi-check' : 'pi pi-copy'"
        class="p-button-rounded p-button-text copy-button"
        [class.p-button-success]="codiceCopiato"
        (click)="copiaCodice()"
        [pTooltip]="codiceCopiato ? 'Codice copiato!' : 'Copia codice'"
        tooltipPosition="top">
      </button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Chiudi"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="chiudiModaleCodice()">
    </button>
  </ng-template>
</p-dialog>

 <!--  <small *ngIf="schedaForm.get('comune')?.invalid && schedaForm.get('comune')?.touched" class="form-error">
          Seleziona un comune
        </small> -->
